import {
    signIn,
    signOut,
    fetchAuthSession,
    signInWithRedirect,
    confirmResetPassword,
} from 'aws-amplify/auth';
import { SuSyApi } from '../api/susyApi';
import { validatePasswordPolicy } from '../api/user';

export const cognitoSignIn = async (email: string, password: string) => {
    return await signIn({ username: email.toLowerCase(), password });
};

export const cognitoSignOut = async () => {
    await signOut();
};

export const getToken = async (): Promise<string | null> => {
    let token = '';
    try {
        const { tokens } = await fetchAuthSession();
        token = tokens?.idToken?.toString() || '';
    } catch (e) {
        return token;
    }
    return token;
};

export const federatedCLMSignIn = async () => {
    await signInWithRedirect({ provider: { custom: 'CLM-Shibboleth' } });
};

export const resetPassword = async (email: string): Promise<void> => {
    await SuSyApi.post(
        '/auth/forgot-password',
        {
            email,
        },
        {
            skipAuth: true,
        }
    );
};

export const completeResetPassword = async (
    username: string,
    code: string,
    password: string
) => {
    await validatePasswordPolicy(username, password);
    await confirmResetPassword({
        username,
        confirmationCode: code,
        newPassword: password,
    });
};
